import { appConstants } from "@app/core/appConstants"

export class CachingHelper {
  /** SHA-256 of a byte range, hex-encoded. */
  private static async hashBytes(bytes: ArrayBuffer): Promise<string> {
    const hashBuffer = await crypto.subtle.digest("SHA-256", bytes)
    return Array.from(new Uint8Array(hashBuffer))
      .map((byte) => byte.toString(16).padStart(2, "0"))
      .join("")
  }

  /**
   * Hash of a file without caching it. Deterministic: the same bytes always give the same hash.
   */
  static async hashFile(file: File): Promise<string> {
    return this.hashBytes(await file.arrayBuffer())
  }

  /**
   * Drops the copies of maquette files the app kept in the browser (US 2441 format and the older one): a saved
   * maquette is shown from its .frag and its stored elements, its IFC is never read again (US 2545).
   */
  static async dropIfcCaches(): Promise<void> {
    if (typeof caches === "undefined") return
    await caches.delete(appConstants.cacheApi.IFC_CACH_LEGACY)
    await caches.delete(appConstants.cacheApi.IFC_CACH)
  }
}
